import { jsxs as t, jsx as l } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as e } from "./index.es2447.js";
function V({ size: i = e }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: i,
      height: i,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l("rect", { y: "0.468262", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M38.693 17.4683H18V38.1613H31.536V26.5686C31.536 26.1429 32.0509 25.93 32.3516 26.2314L38.693 32.5881V17.4683Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M32.3517 26.2316C32.051 25.9302 31.5361 26.1431 31.5361 26.5688V39.6714C31.5361 40.0935 32.0435 40.308 32.3463 40.014L34.1331 38.2787C34.3741 38.0447 34.7751 38.126 34.9058 38.4355L36.6143 42.4822C36.7171 42.7257 36.9982 42.8394 37.2413 42.7358L39.8292 41.6339C40.0701 41.5313 40.1835 41.2538 40.0833 41.0118L38.5198 37.2375C38.3896 36.9231 38.6206 36.5772 38.961 36.5772H41.5215C41.9467 36.5772 42.1599 36.0634 41.8596 35.7625L32.3517 26.2316Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ l("path", { d: "M18 17.4683V20.0549H19.1938V18.6621H20.5866V17.4683H18Z", fill: "#5E63E5" }),
        /* @__PURE__ */ l("path", { d: "M25.7599 17.4683H30.9331V18.6621H25.7599V17.4683Z", fill: "#5E63E5" }),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M36.1064 18.6621V17.4683H38.693V20.0549H37.4992V18.6621H36.1064Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l("path", { d: "M37.4992 25.2281H38.693V30.4014H37.4992V25.2281Z", fill: "#5E63E5" }),
        /* @__PURE__ */ l("path", { d: "M30.9331 36.9674V38.1613H25.7599V36.9674H30.9331Z", fill: "#5E63E5" }),
        /* @__PURE__ */ l("path", { d: "M20.5866 36.9674V38.1613H18V35.5746H19.1938V36.9674H20.5866Z", fill: "#5E63E5" }),
        /* @__PURE__ */ l("path", { d: "M19.1938 30.4014H18V25.2281H19.1938V30.4014Z", fill: "#5E63E5" }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31.5361 39.6712C31.5361 40.0933 32.0435 40.3078 32.3463 40.0138L34.1331 38.2785C34.3741 38.0445 34.7751 38.1259 34.9057 38.4353L36.6143 42.482C36.7171 42.7255 36.9982 42.8392 37.2413 42.7356L39.8292 41.6337C40.0701 41.5311 40.1835 41.2536 40.0833 41.0116L38.5198 37.2373C38.3895 36.9229 38.6206 36.577 38.961 36.577H41.5215C41.9467 36.577 42.1599 36.0632 41.8596 35.7623L32.3517 26.2314C32.051 25.93 31.5361 26.1429 31.5361 26.5686V39.6712ZM33.3014 37.4221L32.7299 37.9771V28.3009L39.7952 35.3832H38.961C37.7698 35.3832 36.961 36.5937 37.4168 37.6942L38.7089 40.8132L37.4347 41.3557L36.0056 37.971C35.5482 36.8878 34.1449 36.6029 33.3014 37.4221Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
V.__tags = [];
export {
  V as MetricSelectedIcon
};
//# sourceMappingURL=index.es422.js.map
